<form edlFocusTrap [formGroup]="form" (ngSubmit)="onSubmit(form)">
    <div class="modal-header">
        <h4 class="modal-title">Advanced Search</h4>
        <button type="button" class="btn btn-link cancel" aria-label="Close" (click)="activeModal.dismiss('cancel')"><i class="fas fa-times" aria-hidden="true"></i></button>    </div>
    <div class="modal-body">
        <div class="form-group">
            <label for="searchName" class="form-label">Name: </label>
            <input type="Name" id="searchName" formControlName="Name" class="form-control" placeholder="Name">
        </div>
        <div class="form-group">
            <edl-floating-label-container label="Filter By" for="statusFilterAdvanced"  >
                <select id="statusFilterAdvanced" formControlName="Status" class="form-select filter-status">
                    <option *ngFor="let status of Statuses" [value]="status.value" [disabled]="status.disabled">{{status.label}}</option>
                </select>
            </edl-floating-label-container>
        </div>
        <div class="form-group">
            <edl-floating-label-container label="User Status" for="userArchivedFilter"  >
                <select id="userArchivedFilter" formControlName="UserArchivedFilter" class="form-select user-archived-filter">
                    <option [value]="UserArchivedFilter.Active">Active</option>
                    <option [value]="UserArchivedFilter.All">All</option>
                    <option [value]="UserArchivedFilter.Archived">Archived</option>
                </select>
            </edl-floating-label-container>
        </div>
        <div class="form-group" *ngIf="Approvers && Approvers.length > 0">
            <edl-floating-label-container label="Approver" for="approverFilter"  >
                <select id="approverFilter" formControlName="ApproverUserId" class="form-select approvers-selector">
                    <option value="">All Approvers</option>
                    <option *ngFor="let approver of Approvers" [value]="approver.UserID">{{approver.DisplayName}}</option>
                </select>
            </edl-floating-label-container>
        </div>
        <div class="form-group" *ngIf='isAct48Enabled'>
            <edl-floating-label-container label="Act 48 Status" for="act48StatusFilter"  >
                <select id="act48StatusFilter" formControlName="Act48Status" class="form-select act-48-status">
                    <option *ngFor="let status of A48_STATUS_FILTERS" [ngValue]="status.value" [disabled]="status.disabled">{{status.label}}</option>
                </select>
            </edl-floating-label-container>
        </div>
        <div class="form-group" *ngIf="Groups && Groups.length > 0">
            <ngb-accordion [closeOthers]="true" activeIds="ngb-panel-0">
                <ngb-panel>
                    <ng-template ngbPanelTitle>
                        <span class="panel-title">Groups ({{selectedGroupsCount}})</span>
                        <span class="panel-sub-title">
                            <button type="button" class="btn btn-secondary ps-2 pe-2" (click)="onClearGroupsClicked($event)">Clear All</button>
                        </span>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="groups mb-2">
                            <ul formArrayName="Groups" class="groups-selector">
                                <li *ngFor="let group of Groups; let i = index">
                                    <input type="checkbox" [formControlName]="i" (change)="setSelectedGroupCount()" id="group_{{i}}" /> 
                                    <label class="ms-2 form-label" for="group_{{i}}">{{ group.GroupName }}</label>
                                </li>
                            </ul>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary yes-button">Search</button>
        <button type="button" class="btn btn-info clear-button" (click)="clear()">Clear</button>
    </div>
</form>
